import { jsxs as _jsxs } from "react/jsx-runtime";
import { footerStyles } from './Footer.style';
var Footer = function () {
    var classes = footerStyles().classes;
    var year = new Date().getFullYear();
    return (_jsxs("div", { className: classes.footer, "data-testid": 'print-footer', children: ["\u00A9 ", year, " ClearWellness, LLC. All Rights Reserved."] }));
};
export default Footer;
